import halfBackground from '../../../assets/images/onboardPage/onboard_grid_bg.png'
import { Box, useMediaQuery } from '@mui/material';
import Grid from '@mui/material/Grid2';
import logo from '../../../assets/images/onboardPage/hypercept_logo.png'
import { theme } from '../../../utils/theme/godzilla_light';
import lifeLogo from '../../../assets/images/onboardPage/lifegraph_logo.png'

const styles = {
    bgContainer: {
        backgroundImage: `url(${halfBackground})`,
        height: "100%",
        backgroundSize: "100% 100%",
        backgroundRepeat: "no-repeat"
    },
    footerImage: {
        display: "flex",
        justifyContent: "flex-start",
        alignItems: 'flex-end',
        flex: 1,
        height: "100%",
        borderRight: `20px solid ${theme.palette.primary.main}`,
    }
}
interface IOnboardGridLayoutProps {
    children: React.ReactNode
}

const OnboardGridLayout = (props: IOnboardGridLayoutProps) => {
    const { children } = props
    const isMobile = useMediaQuery(theme.breakpoints.down(1024))

    return (
        <Grid container sx={{height:"100vh"}}>
            {!isMobile ? (
            <Grid  size={{ xs: 12, md: 6 }}>
                <Box sx={styles.bgContainer}>
                    <Box sx={styles.footerImage}>
                        <img src={lifeLogo} style={{ height: "3.125rem", width: "13.125rem",paddingBottom:"40px",paddingLeft:"40px" }} alt="lifegraph-profile-info" />
                    </Box>
                </Box>
            </Grid>
            ) : null}
            <Grid  size={{ xs: 12, md: 6 }} display={"flex"}>
                <Box sx={{ py:"30px",px:"72px",width:"100%",display:"flex",flexDirection:"column",alignItems: 'center',justifyContent:"center"}}>
                    <img src={logo} style={{ height: "51px", width: "400px",marginBottom:"24px" }} alt='astellas-logo-profile-info' />
                    {children}
                </Box>
            </Grid>
        </Grid>
    );
}

export default OnboardGridLayout